import type * as Sentry from '@sentry/ember';
import type ErrorTrackingService from 'frontend-utils/services/error-tracking';

/**
 * Log messages to help debugging. Adds Sentry breadcrumbs for all users, but also prints to
 * console for staff users
 *
 * @param logInfo
 * @param errorTrackingService
 * @param isStaffUser
 */

export function logMessage(
  logInfo: Sentry.Breadcrumb,
  errorTrackingService: ErrorTrackingService,
  isStaffUser?: boolean,
): void {
  errorTrackingService.addBreadcrumb(logInfo);

  if (isStaffUser) {
    if (logInfo?.message) {
      console.log(logInfo.message);
    }
    if (logInfo?.data) {
      console.dir(logInfo.data);
    }
  }
}
